export default __webpack_public_path__ + "static/media/spinner.706f6ba7.gif";